import React from 'react';
import ImportKlientowMapping from './ImportKlientowMapping';

function Home() {
    return (
        <div style={{ padding: '20px' }}>
            <h1>Witaj w Aplikacji CRM</h1>
            <ImportKlientowMapping />
        </div>
    );
}

export default Home;